var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.333v-5a4.333 4.333 0 018.667 0v5M8.333 14v3.333M13.667 10.334H3a2 2 0 00-2 2V19a2 2 0 002 2h10.667a2 2 0 002-2v-6.666a2 2 0 00-2-2z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconLock;